/**
 * @module FE-CU50_ユーザー情報変更_秘密の質問
 */
import Header from '../../../components/header/Header.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import PCFooter from '@/components/footer/PCFooter.vue';

const PAGE_ID = 'FE-CU50';

export default {
  name: 'SecretQuestionEdit',
  components: {
    Header,
    PcPageTitle,
    MobileFooter,
    BreadCrumbList,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU50ユーザー情報変更秘密の質問.ユーザー情報変更'),
      hintText: vm.$vuetify.lang.t(
        '$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.C0001'
      ),
      question: '',
      answer: '',
      password: '',
      showPassword: false,
      passwordDialog: false,
      valid: true,
      hasQuestionError: false,
      hasAnswerError: false,
      // isDisabled: true,
      modified: '',
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    questionRules() {
      return [
        !!this.question ||
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.E0006'),
      ];
    },

    answerRules() {
      if (this.answer === '') {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0001'
          ),
        ];
      }

      if (this.hiraganaPattern.test(this.answer)) {
        return [true];
      } else {
        return [
          this.$vuetify.lang.t(
            '$vuetify.メッセージ一覧.FECU05パスワード初期化画面秘密の質問.E0005'
          ),
        ];
      }
    },

    passwordRules() {
      if (this.password === '') {
        return [
          this.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.C0003'),
        ];
      }
    },

    hiraganaPattern() {
      return /^[\u3041-\u3094]+$/;
    },
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU50ユーザー情報変更秘密の質問.ユーザー情報変更'),
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.C0001'
        ),
      };
    },

    isDisabled() {
      return !(this.valid && this.hiraganaPattern.test(this.answer));
    },
    validatePassword() {
      return this.password === '' || this.password === null;
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * APP_CU5001 ユーザー情報取得（秘密の質問）
     * @param {string} param エンドポイント
     * @param {object} queries リクエスト
     * @param {string} method HTTPメソッド
     * @returns {object} レスポンス
     */
    APP_CU5001: async function (param, queries, method) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

            // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     secretQuestion: "出身都道府県は？",
            //     modified: "2022-05-10 14:00:00",
            //   },
            // };

            // 取得したデータをマッピングする
            this.question = apiData.contentsInfo.secretQuestion;
            this.modified = apiData.contentsInfo.modified;
          },
          (error) => {
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * APP_CU5002 ユーザー情報更新（秘密の質問）
     */
    APP_CU5002: function () {
      this.$_setLoading(true);
      let param = '/api/changeUserInfoOfSecretQuestion/update';
      // let param = "post";
      let method = 'post';

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        secretQuestion: this.question,
        secretAnswer: this.answer,
        password: this.password,
        modified: this.modified,
      };

      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            // apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // レスポンスなし
            this.callMessageDialog('$vuetify.FECU50ユーザー情報変更秘密の質問.変更が完了しました');
          },
          (error /* eslint-disable-line */) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.E0011');
            } else if (error.message.includes('401')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.E0005');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
    },
    /**
     * お知らせダイアログ（共通）
     * @param {string} text ダイアログメッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);

      // FE-CU34 アカウント管理(ユーザー情報)画面に遷移
      this.closeDialog();
      this.$router.back('userInfoAccountManagement');
    },
    /**
     * 確認ダイアログ
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU50ユーザー情報変更秘密の質問.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        this.passwordDialog = true;
      }
    },
    /**
     * 変更ボタン活性制御判定
     */
    validate() {
      if (!this.question) {
        this.hasQuestionError = true;
      } else {
        this.hasQuestionError = false;
      }

      if (!this.answer || !this.hiraganaPattern.test(this.answer)) {
        this.hasAnswerError = true;
      } else {
        this.hasAnswerError = false;
      }

      // 変更ボタンの活性制御
      if (this.hasQuestionError === true || this.hasAnswerError === true) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * 変更確認ダイアログ「中止ボタン」押下処理
     */
    closeDialog() {
      this.password = '';
      this.$refs.passwordForm.reset();
      this.passwordDialog = false;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    //ローディングマーク表示と合わせて色々再見直ししたほうが良いかも
    this.isShowPage = true;

    let param = '/api/changeUserInfoOfSecretQuestion/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
    };

    let method = 'post';

    // APP_CU5001
    await this.APP_CU5001(param, queries, method);
  },
};
